module.exports = __webpack_public_path__ + "media/images/athletes/1880-170d60d04f058aa75336ff201f676cea.png";